import { render } from "./page-item.vue?vue&type=template&id=d0eb9e56"
import script from "./page-item.vue?vue&type=script&lang=js"
export * from "./page-item.vue?vue&type=script&lang=js"
script.render = render

export default script